
import { registrationConstants, profileConstants, workflowConstants } from "../_constants";
import { metadataService, newLoanStepperService } from "../_services";

const registrationInitialState = {
    existingCustomer: false,
    firstName: "", lastName: "", email: "", confirmEmail: "", mobileNumber: "",alternateMobileNumber : "", address: "", address2: "", city: "", state: "", postalCode: "", language: "",
    dateOfBirth: "", idNumber: "", userHash: "", monthofBirth: "", dayOfBirth: "", yearOfBirth: "", isIDConsular: false, isIDSSN: true,
    password: "", confirmPassword: "",
    codeToEmail: null, emailValidationToken: "", emailCodeIsValid: "",
    textisOptIn: true, textisOptOut: false, textValidationTokenId: "", codeToPhone: "", phoneCodeIsValid: false,
    confirmationSummaryScreen: false,
    profileCreated: false,
    fetching: false,
    error: false,
    errorString: null,
    postingData: false, 
    completedSteps: [], 
    isBusy: false,
    employer: "",
    employmentStatus: "",
    numYearsAtEmployer: "",
    numMonthsAtEmployer: "",
    workNumber: "",
    incomePerPeriod: "",
    payFrequency: "",
    otherIncomeSource: "",
    monthlyOtherIncome: "",
    requestedAmount: 0,
    campaign: "",
    }

export function registration(state = registrationInitialState, action) {
    let stepsCompleted = state.completedSteps; 
    switch (action.type) {
        case registrationConstants.NEW_EXISTING_CUSTOMER_REQUEST:
            stepsCompleted.push(registrationConstants.NEW_EXISTING_CUSTOMER_REQUEST);
            
            return {
                ...state,
                ...registrationInitialState, 
                existingCustomer: action.existingCustomer.existingCustomer,
                steps: newLoanStepperService(workflowConstants.EXISTING_CUSTOMER_REGISTRATION_WORKFLOW),
                error: false,
                errorString: "",
                postingData: false, 
                completedSteps : stepsCompleted
            };
        case registrationConstants.NEW_CUSTOMER_REQUEST:
            stepsCompleted.push(registrationConstants.NEW_CUSTOMER_REQUEST);
            return {
                ...state,
                firstName: action.firstName,
                lastName: action.lastName,
                email: action.email,
                confirmEmail: action.email,
                mobileNumber: action.mobilePhoneNumber,
                alternateMobileNumber: action.alternateMobilePhoneNumber,
                state: action.borrowerState,
                requestedAmount: action.requestedAmount,
                preApprovalCode: action.preApprovalCode,
                existingCustomer: JSON.parse(sessionStorage.getItem("existingCustomer")),
                error: false,
                errorString: "",
                postingData: false,
                completedSteps: stepsCompleted
            };
        case registrationConstants.NEW_CUSTOMER_GET_STARTED_REQUEST:
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: false,
                completedSteps: stepsCompleted
            };
        case registrationConstants.NEW_EXISTING_CUSTOMER_ERROR:
            return {
                ...state,
                existingCustomer: "",
                error: true,
                errorString: action.errorString,
                postingData: false
            };
        case registrationConstants.GET_STARTED_INFORMATION_REQUEST:
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: false,
                steps: newLoanStepperService("newApplication"),
                step: 1,
                completedSteps: stepsCompleted
            };
        case registrationConstants.GET_STARTED_INFORMATION_FAILURE:
            return {
                ...state,
                error: true,
                errorString: action.errorString,
                postingData: false
            };
        case registrationConstants.PERSONAL_INFORMATION_REQUEST:
            stepsCompleted.push(registrationConstants.PERSONAL_INFORMATION_REQUEST);
            return {
                ...state,
                firstName: action.personalInformation.firstName,
                lastName: action.personalInformation.lastName,
                email: action.personalInformation.email,
                confirmEmail: action.personalInformation.confirmEmail,
                mobileNumber: action.personalInformation.mobileNumber,
                alternateMobileNumber: action.personalInformation.alternateMobileNumber,
                address: action.personalInformation.address,
                address2: action.personalInformation.address2, 
                city: action.personalInformation.city,
                state: action.personalInformation.state,
                postalCode: action.personalInformation.postalCode,
                socialSecurityNumber: action.personalInformation.socialSecurityNumber,
                individualTaxIdentificationNumber: action.personalInformation.individualTaxIdentificationNumber,
                dateOfBirth: action.personalInformation.dateOfBirth,
                yearsInHome: action.personalInformation.yearsInHome,
                monthsInHome: action.personalInformation.monthsInHome,
                rentOrOwn: action.personalInformation.rentOrOwn,
                language: action.personalInformation.language,
                confirmationSummaryScreen: false,
                error: false,
                errorString: null,
                postingData: false, 
                completedSteps: stepsCompleted,
                steps: newLoanStepperService("newApplication"),
                step: 2
            };

        case registrationConstants.PERSONAL_INFORMATION_FAILURE:
            return {
                ...state,
                firstName: "",
                lastName: "",
                email: "",
                confirmEmail: "",
                mobileNumber: "",
                alternateMobileNumber: "",
                address: "",
                city: "",
                state: "",
                postalCode: "",
                socialSecurityNumber: "",
                individualTaxIdentificationNumber: "",
                dateOfBirth: "",
                yearsInHome: "",
                monthsInHome: "",
                rentOrOwn: "",
                language: "",
                error: true,
                errorString: action.errorString,
                postingData: false
            };
        case registrationConstants.PERSONAL_INFORMATION_BACK_REQUEST:
            stepsCompleted.push(registrationConstants.PERSONAL_INFORMATION_REQUEST);
            return {
                ...state,
                confirmationSummaryScreen: false,
                error: false,
                errorString: null,
                postingData: false,
                completedSteps: stepsCompleted,
                steps: newLoanStepperService("newApplication"),
                step: 0
            };

        case registrationConstants.PERSONAL_INFORMATION_BACK_FAILURE:
            return {
                ...state,
                firstName: "",
                lastName: "",
                email: "",
                confirmEmail: "",
                mobileNumber: "",
                address: "",
                city: "",
                state: "",
                postalCode: "",
                language: "",
                error: true,
                errorString: action.errorString,
                postingData: false
            };
        case registrationConstants.FINANCIAL_INFORMATION_REQUEST:
            stepsCompleted.push(registrationConstants.FINANCIAL_INFORMATION_REQUEST);
            return {
                ...state,
                confirmationSummaryScreen: false,
                error: false,
                errorString: null,
                postingData: false,
                completedSteps: stepsCompleted,
                employmentStatus: '',
            };
        case registrationConstants.FINANCIAL_INFORMATION_FAILURE:
            return {
                ...state,
                firstName: "",
                lastName: "",
                email: "",
                confirmEmail: "",
                mobileNumber: "",
                alternateMobileNumber: "",
                address: "",
                city: "",
                state: "",
                postalCode: "",
                language: "",
                error: true,
                errorString: action.errorString,
                postingData: false
            };
        case registrationConstants.FINANCIAL_INFORMATION_BACK_REQUEST:
            stepsCompleted.push(registrationConstants.FINANCIAL_INFORMATION_BACK_REQUEST);
            return {
                ...state,
                confirmationSummaryScreen: false,
                error: false,
                errorString: null,
                postingData: false,
                completedSteps: stepsCompleted,
                steps: newLoanStepperService("newApplication"),
                step: 1
            };

        case registrationConstants.FINANCIAL_INFORMATION_BACK_FAILURE:
            return {
                ...state,
                firstName: "",
                lastName: "",
                email: "",
                confirmEmail: "",
                mobileNumber: "",
                alternateMobileNumber: "",
                address: "",
                city: "",
                state: "",
                postalCode: "",
                language: "",
                error: true,
                errorString: action.errorString,
                postingData: false
            };

        case registrationConstants.WELCOME_NEXT_REQUEST:
            stepsCompleted.push(registrationConstants.WELCOME_NEXT_REQUEST);
            return {
                ...state,
                completedSteps: stepsCompleted,
                leadId: action.leadId,
                email: action.email,
                mobileNumber: action.mobileNumber
            };
        case registrationConstants.WELCOME_NEXT_FAILURE:
            return {
                ...state,
                error: true,
                errorString: action.errorString,
                postingData: false
            };
        case registrationConstants.IDTYPE_AND_NUMBER_REQUEST:
            stepsCompleted.push(registrationConstants.IDTYPE_AND_NUMBER_REQUEST);
            return {
                ...state, 
                monthofBirth: action.idTypeAndNumber.monthofBirth,
                dayOfBirth: action.idTypeAndNumber.dayOfBirth,
                yearOfBirth: action.idTypeAndNumber.yearOfBirth,                
                dateOfBirth: action.idTypeAndNumber.dateOfBirth,
                idNumber: action.idTypeAndNumber.idNumber,
                isIDSSN: action.idTypeAndNumber.isIDSSN,
                isIDConsular: action.idTypeAndNumber.isIDConsular,
                error: false,
                errorString: null,
                postingData: true
            };
        case registrationConstants.IDTYPE_AND_NUMBER_SUCCESS:
            const { userHash, email, phoneNumber, firstName, lastName } = action.registrationInfo;

            return {
                ...state,
                userHash: userHash,
                email: email,
                mobileNumber: phoneNumber,
                confirmationSummaryScreen: false,
                firstName: firstName,
                lastName: lastName,
                error: false,
                errorString: "",
                postingData: false
            };

        case registrationConstants.IDTYPE_AND_NUMBER_FAILURE:
            return {
                ...state,
                dateOfBirth: "",
                idNumber: "",
                userHash: "",
                fetching: false,
                error: true,
                errorString: action.errorString,
                postingData: false
            };

        case registrationConstants.PASSWORD_CREATE_ERROR:
            return {
                ...state,
                password: "",
                confirmPassword: "",
                error: true,
                errorString: action.errorString,
                postingData: false
            };

        case registrationConstants.CONFIRMATION_SUMMARY_NAVIGATION_REQUEST:
            return {
                ...state,
                confirmationSummaryScreen: true
            };

        case registrationConstants.CONFIRMATION_SUMMARY_NAVIGATION_RESPONSE:
            return {
                ...state,
                confirmationSummaryScreen: false,
                error: false,
                errorString: "",
                postingData: false
            }
        case registrationConstants.CONFIRMATION_SUMMARY_REQUEST:
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: false
            };


        case registrationConstants.CONFIRMATION_SUMMARY_RESPONSE:
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: false
            };

        case registrationConstants.CONFIRMATION_SUMMARY_ERROR:
            return {
                ...state,
                error: true,
                errorString: action.errorString,
                postingData: false,
                confirmationSummaryScreen: false,
                isBusy: false
            };
        case registrationConstants.SEND_EMAIL_CODE_REQUEST:
            stepsCompleted.push(registrationConstants.SEND_EMAIL_CODE_REQUEST);
            return {
                ...state,
                password: action.passwords.password,
                confirmPassword: action.passwords.confirmPassword,
                codeToEmail: action.emailConfirmation.codeToEmail,
                emailValidationToken: "",
                emailCodeIsValid: false,
                error: false,
                postingData: true, 
                isBusy : true,
            };
        case registrationConstants.SEND_EMAIL_CODE_RESPONSE:
                stepsCompleted.push(registrationConstants.SEND_EMAIL_CODE_RESPONSE);
            return {
                ...state,
                emailValidationToken: action.tokenId,
                emailCodeIsValid: false,
                error: false,
                postingData: false,
                isBusy: false
            };
        case registrationConstants.SEND_EMAIL_CODE_ERROR:
            return {
                ...state,
                emailValidationToken: "",
                emailCodeIsValid: false,
                error: true,
                errorString: action.errorString,
                postingData: false,
                isBusy: false
            };
        case registrationConstants.SEND_EMPTY_EMAIL_ERROR:
            return {
                ...state,
                emailValidationToken: "",
                emailCodeIsValid: false,
                postingData: false,
                isBusy: false
            };
        case registrationConstants.EMAIL_CODE_VALIDATION_REQUEST:
            return {
                ...state,
                error: false,
                postingData: false
            };
        case registrationConstants.EMAIL_CODE_VALIDATION_RESPONSE:
                stepsCompleted.push(registrationConstants.EMAIL_CODE_VALIDATION_RESPONSE);
            return {
                ...state,
                emailCodeIsValid: action.emailCodeIsValid,
                error: false,
                errorString: ""
            };
        case registrationConstants.EMAIL_CODE_VALIDATION_ERROR:
            return {
                ...state,
                emailCodeIsValid: false,
                error: true,
                errorString: action.errorString,
                postingData: false,
                isBusy: false
            };
        case registrationConstants.PROFILE_CREATE_REQUEST:
                
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: true
            };
        case registrationConstants.PROFILE_CREATE_RESPONSE:
            stepsCompleted.push(registrationConstants.PROFILE_CREATE_REQUEST);
            return {
                ...state,
                existingCustomer: false,
                firstName: "",
                lastName: "",
                confirmEmail: "",
                address: "",
                address2: "", 
                city: "",
                state: "",
                postalCode: "",
                language: "",
                dateOfBirth: "",
                idNumber: "",
                userHash: "",
                monthofBirth: "",
                dayOfBirth: "",
                yearOfBirth: "",
                isIDConsular: false,
                isIDSSN: true,
                password: "",
                confirmPassword: "",
                codeToEmail: "",
                emailValidationToken: "",
                emailCodeIsValid: "",
                error: false,
                errorString: "",
                profileCreated: true,
                postingData: false, 
                isBusy: false
            };
        case registrationConstants.PROFILE_CREATE_ERROR:
            return {
                ...state,
                profileCreated: false,
                error: true,
                errorString: action.errorString,
                postingData: false,
                isBusy: false
            };
        case registrationConstants.TEXT_OPTIN_REQUEST:
            stepsCompleted.push(registrationConstants.TEXT_OPTIN_REQUEST);
            return {
                ...state,
                textisOptIn: action.textOptIn,
                textisOptOut: action.textisOptOut,
                error: false,
                errorString: "",
                postingData: false,
                isBusy: false
            };
        case registrationConstants.TEXT_OPTIN_RESPONSE:
            return {
                ...state,
                textValidationTokenId: action.tokenId,
                error: false,
                errorString: "",
                postingData: false,
                isBusy: false
            };
        case registrationConstants.TEXT_OPTIN_FAILURE:
            return {
                ...state,
                textisOptIn: true,
                textisOptOut: false,
                codeToPhone: "",
                phoneCodeIsValid: false,
                textValidationTokenId: "",
                error: true,
                errorString: action.errorString,
                postingData: false
            };
        case registrationConstants.TEXT_OPTOUT_REQUEST:
            stepsCompleted.push(registrationConstants.TEXT_OPTOUT_REQUEST);
            return {
                ...state,
                textisOptIn: true,
                textisOptOut: false,
                completedSteps: [],
                email: "", 
                mobileNumber: "",
                alternateMobileNumber: "",
                codeToPhone: "",
                phoneCodeIsValid: false,
                textValidationTokenId: "",
                error: false,
                errorString: "",
                postingData: false
            };
        case registrationConstants.TEXT_OPTOUT_ERROR:
            return {
                ...state,
                textisOptIn: true,
                textisOptOut: false,
                codeToPhone: "",
                phoneCodeIsValid: false,
                textValidationTokenId: "",
                error: false,
                errorString: action.errorString,
                postingData: false
            };
        case registrationConstants.CONFIRM_PHONE_CODE_REQUEST:
                stepsCompleted.push(registrationConstants.TEXT_OPTOUT_REQUEST);
            return {
                codeToPhone: action.TextOptIn.codeToPhone,
                phoneCodeIsValid: "",
                error: false,
                postingData: false,
                isBusy: false,
                userLogged : state.userLogged
            };
        case registrationConstants.CONFIRM_PHONE_CODE_RESPONSE:
            return {
                ...state,
                completedSteps: [],
                codeToPhone: "",
                phoneCodeIsValid: "",
                email: "", 
                mobileNumber: "",
                alternateMobileNumber: "",
                error: false,
                postingData: false,
                isBusy: false
            };
        case registrationConstants.CONFIRM_PHONE_CODE_ERROR:
            return {
                ...state,
                codeToPhone: true,
                phoneCodeIsValid: "",
                error: false,
                errorString: action.message, 
                postingData: false,
                isBusy: false
            };
        case registrationConstants.SET_BUSY:
            return {
                ...state, 
                isBusy: action.isBusy
            }
        case registrationConstants.SET_MARKETING_COOKIES:
            const { marketingCookies } = action;
            return {
                ...state,
                marketingCookies: marketingCookies
            }
        case registrationConstants.POPULATE_REGISTRATION_DATA:
            // Rehydrate the registration state with whats in session
            const { data } = action;
            return {
                ...state,
                existingCustomer: false,
                firstName: data.firstName,
                lastName: data.lastName,
                confirmEmail: data.confirmEmail,
                address: data.address,
                address2: data.address2,
                city: data.city,
                state: data.state,
                postalCode: data.postalCode,
                language: data.language,
                dateOfBirth: data.dateOfBirth,
                userHash: data.userHash,
                mobileNumber: data.mobileNumber,
                alternateMobileNumber: data.alternateMobileNumber,
                socialSecurityNumber: data.socialSecurityNumber,
            }
        case registrationConstants.REGISTRATION_LOGIN_SUCCESS:
            // Rehydrate the registration state with whats in session
            const { user } = action;
            return {
                ...state,
                userLogged : user 
            } 
            case registrationConstants.RE_SEND_EMAIL_CODE_REQUEST:                 
                return {
                    ...state,
                    codeToEmail: action.codeToEmail,
                    emailValidationToken: "",
                    emailCodeIsValid: false,
                    error: false,
                    postingData: true, 
                    isBusy : true,
                };
            case registrationConstants.RE_SEND_EMAIL_CODE_RESPONSE: 
                return {
                    ...state,
                    emailValidationToken: action.tokenId,
                    emailCodeIsValid: false,
                    error: false,
                    postingData: false,
                    isBusy: false
                };
            case registrationConstants.RE_SEND_EMAIL_CODE_ERROR:
                return {
                    ...state,
                    emailValidationToken: "",
                    emailCodeIsValid: false,
                    error: true,
                    errorString: action.errorString,
                    postingData: false,
                    isBusy: false
                };
            case registrationConstants.SIGNUP_EMAIL_VALIDATION_BACK_REQUEST:                 
                return {
                    ...state,                    
                    password: "",
                    confirmPassword: "", 
                    emailValidationToken: "",
                    emailCodeIsValid: false,
                    error: false,
                    postingData: false, 
                    isBusy : false,
                };  
        case registrationConstants.GUEST_PAYMENT_REGISTRATION_REQUEST:
            return {
                ...state,
                existingCustomer: true,
                userHash: action.userHash
            }
        case registrationConstants.GUEST_PAYMENT_REGISTRATION_SUCCESS:
            return {
                ...state,
                ...action.userData,
                existingCustomer: true,
                completedSteps: stepsCompleted
            }
        default:
            return state;
    }
}
